export default __webpack_public_path__ + "images/star.765894deeb8923e7971d458848ba07ff.png";